<template>
  <!-- 提货派车 -->
  <div class="container">
    <!-- 按钮列表 -->
    <div class="glo_btnList" ref="btnList">
      <div class="glo_btnList_left">
        <el-button
          class="glo_btnItems glo_bgcMainColor"
          @click="addNewDispatch()"
          v-permission="permission('location')"
          >GPS定位
        </el-button>
        <el-button
          class="glo_btnItems"
          @click="arriveMidway()"
          v-permission="permission('zhong:tu:dao:che')"
          >中途到车</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="addUnLoadOrder()"
          v-permission="permission('unload')"
          >卸货</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="addLoadOrder()"
          v-permission="permission('load')"
          >装货</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="departureMidway()"
          v-permission="permission('zhong:tu:fa:che')"
          >中途发车</el-button
        >
        <el-button
          class="glo_btnItems"
          @click="terminalArrival()"
          v-permission="permission('zhong:duan:dao:che')"
          >终端到车</el-button
        >
        <el-dropdown class="topDropDown" @command="topCommandBtns">
          <el-button type="primary">
            更多操作<i class="el-icon-arrow-down el-icon--right"></i>
          </el-button>
          <el-dropdown-menu slot="dropdown">
            <el-dropdown-item command="dtdc">导出</el-dropdown-item>
            <el-dropdown-item command="bgsz">表格设置</el-dropdown-item>
          </el-dropdown-menu>
        </el-dropdown>
      </div>

      <queryBtns
        :MoreConditions="MoreConditions"
        @clerBtns="clerBtns"
        @queryBtn_ok="queryBtn_ok"
        @moreParam="moreParam"
      ></queryBtns>
    </div>
    <!-- 查询条件 -->
    <queryCondition
      ref="queryForm"
      :More="isHaseMore"
      :formConfig="queryCondditionDatas"
    ></queryCondition>
    <!-- 表格 -->
    <mytable
      ref="mytable"
      :tableHeigth="tableHeigth"
      :tableData="tableData"
      :myTableHeard="myTableHeard"
      :isShowOperate="isShowOperate"
      :isShowMoreOperate="isShowMoreOperate"
      :btnsList="btnsList"
      :btnsMoreList="btnsMoreList"
      :Operatewidth="Operatewidth"
      @handleCommandBtns="handleCommandBtns"
    ></mytable>
    <paging
      ref="pags"
      :pageNum="pageStart"
      :total="pageCount"
      :size="pageTotal"
      @handleSizeChange="handleSizeChange"
      @handleCurrentChange="handleCurrentChange"
    ></paging>
    <!--        自定义表头           -->
    <sorttable
      :show_sortTableHeard="show_sortTableHeard"
      :allCheck="allCheck"
      :sortName="sortName"
      :tabelHeadeTitle="tabelHeadeTitle"
      :originalTabelHeadeTitle="originalTabelHeadeTitle"
      :selectLength="selectLength"
      @cancelSortHeard="cancelSortHeard"
      @confirmOk="confirmOk"
      @checktab="checktab"
      @checkAll="checkAll"
      @closeDias="closeDias"
    ></sorttable>

    <!-- 导出 -->
    <exportCompoent
      :isShowDialog_dc="isShowDialog_dc"
      :diaWidth_dc="diaWidth_dc"
      :dialogTitle_dc="dialogTitle_dc"
      :dialogForm_dc="dialogForm_dc"
      :tableHeard="EPtableHeard"
      :AllCheck="EPAllCheck"
      :queryCondditionDatas="queryCondditionDatas"
      @checktabEP="checktabEP"
      @checkAllEP="checkAllEP"
      @onAfterEnter="onAfterEnter"
      @handleCloseDia_dc="handleCloseDia_dc"
      @diaConfirmBtn_dc="diaConfirmBtn_dc()"
    >
    </exportCompoent>
    <!-- 途径网点 -->
    <PassingThroughBranches
      ref="passingThroughBranches"
      :dispatchId="dispatchId"
      v-if="showSetOnway"
      @close="showSetOnway = false"
    />
    <!-- 中途到车/中途发车/终端到车 -->
    <myDialog
      class="ArriveMidway_Dia"
      :diaWidth="'400px'"
      :dialogTitle="arriveDiaTitle"
      :isAppend="true"
      :isShowDialog="showArriveMidwayDia"
      @handleCloseDia="showArriveMidwayDia = false"
      @diaCancelBtn="showArriveMidwayDia = false"
      @diaConfirmBtn="saveArriveMidway"
    >
      <div class="glo_dialogForm">
        <el-form
          v-if="showArriveMidwayDia"
          class="diaForm"
          ref="arriveDialogFormRef"
          :model="arriveDiaForm"
          label-width="120px"
          :rules="rulesForm"
        >
          <el-form-item
            class="dialogFormItemsTime"
            :label="arriveDiaForm.timeLabel"
            prop="arrivalTime"
            required
          >
            <el-date-picker
              v-model="arriveDiaForm.arrivalTime"
              value-format="yyyy-MM-dd HH:mm"
              format="yyyy-MM-dd HH:mm"
              type="datetime"
              placeholder="选择日期时间"
            />
          </el-form-item>
          <el-form-item
            class="dialogFormItems"
            :label="arriveDiaForm.deptLabel"
            prop="deptId"
            required
          >
            <el-select
              v-model="arriveDiaForm.deptId"
              placeholder="请选择"
              clearable
              filterable
            >
              <el-option
                v-for="item in businessDepts"
                :key="item.deptId"
                :label="item.deptName"
                :value="item.deptId"
              ></el-option>
            </el-select>
          </el-form-item>
        </el-form>
      </div>
    </myDialog>
  </div>
</template>
<script>
import tableListNew from "@/pages/tableListNew.js"; //mixins 查询列表页公共方法
import sorttable from "@/components/sortTemplate.vue"; //自定义排序表头
import paging from "@/components/pagings.vue"; //分页组件
import myDialog from "@/components/Dialog.vue";
import mytable from "@/components/table/table.vue";
import queryCondition from "@/components/queryCondition.vue";
import queryBtns from "@/components/queryBtns.vue";
import { mixin_print } from "@/assets/js/Mixins/mixinPrint";
import exportjs from "@/assets/js/Mixins/exportDT.js"; //导出的公共js
import colorStatus from "@/assets/js/Mixins/colorStatus.js"; //导出的公共js
import PassingThroughBranches from "./PassingThroughBranches.vue";
export default {
  inject: ["reload"],
  mixins: [tableListNew, exportjs, mixin_print, colorStatus],
  props: {
    dispatchType: {
      type: String,
      require: false,
      default: "gan_xian_pei_zai",
    },
  },
  components: {
    queryCondition,
    sorttable,
    paging,
    myDialog,
    queryBtns,
    mytable,
    PassingThroughBranches,
  },
  data() {
    return {
      pageGroupName: "admin_finish_car_list_v5", //  页面标识
      reportFiledsNumber: "admin_finish_car_list_v5", // 动态 条件、表头
      isShowOperate: true, //是否显示右边操作
      isShowMoreOperate: true, //是否显示右边更多操作
      // 表格右边操作按钮
      btnsList: [
        {
          name: "修改", //按钮名称
          methods: "dispatchEdit", //当前页面的方法
          param: 1, //自定义参数标记
          permission: this.permission("edit"),
        },
        {
          name: "详情",
          methods: "dispatchDetail",
          param: 2,
          permission: this.permission("detail"),
        },
        // {
        //   name: "装货",
        //   methods: "dispatchDetail",
        //   param: 2,
        //   show: this.dispatchType === "gan_xian_pei_zai",
        // },
        // {
        //   name: "卸货",
        //   methods: "dispatchDetail",
        //   param: 2,
        //   show: this.dispatchType === "gan_xian_pei_zai",
        // },
      ],
      // 表格右边更多的操作按钮
      btnsMoreList: [
        {
          name: "发车完成",
          command: "finishDispatch",
          permission: this.permission("finish"),
        },
      ],
      Operatewidth: "220px", //操作列的列宽
      queryCondditionDatas: [
        {
          conditonKey: "dispatchType",
          conditonVal: this.dispatchType + ":dispatch_type",
        },
        {
          conditonKey: "endDeptId",
          conditonVal: [this.$TOOLS.getUserInfo().departmentId],
        },
      ],
      dispatchId: "", // 表格选中id
      showArriveMidwayDia: false,
      arriveDiaTitle: "",
      arriveDiaForm: {
        timeLabel: "",
        deptLabel: "",
        arrivalTime: "",
        deptId: "",
        deptName: "",
        dispatchId: null,
      },
      businessDepts: [], // 网点
      showSetOnway: false,
      rulesForm: {
        deptId: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
        arrivalTime: [
          { required: true, message: "请选择", trigger: ["blur", "change"] },
        ],
      },
    };
  },
  computed: {
    host: {
      get() {
        return this.getHost();
      },
      set(val){

      }
    },
  },
  updated() {},
  created() {},
  activated() {},
  mounted() {},
  watch: {
    showArriveMidwayDia(n) {
      if (n) {
        // 网点
        this.getBusinessDepts();
        this.arriveDiaForm.arrivalTime = this.$TOOLS.getCurrentTime();
      } else {
        this.arriveDiaForm = {
          timeLabel: "",
          deptLabel: "",
          arrivalTime: "",
          deptId: "",
          deptName: "",
          dispatchId: null,
        };
      }
    },
  },
  methods: {
    getHost() {
      switch (this.dispatchType) {
        case "shang_men_ti_huo":
          return "shangmentihuo";
        case "gan_xian_pei_zai":
          return "ganxian";
        case "song_huo_shang_men":
          return "songhuoshangmen";
        case "song_chu_wai_fa":
          return "songchuwaifa";
      }
      return "shangmentihuo";
    },
    permission(action) {
      return "admin:dispatch:" + this.getHost() + ":" + action;
    },
    addLoadOrder(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      row = this.selectTableData[0];
      //todo 判断是否有关联
      this.$router.push({
        path: "/DispatchCar/EditLoadingOperationSheet",
        query: {
          dispatchId: row.dispatchId,
        },
      });
    },
    addUnLoadOrder(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      row = this.selectTableData[0];
      //todo 判断是否有关联
      this.$router.push({
        path: "/DispatchCar/EditUnloadingOperationSheet",
        query: {
          dispatchId: row.dispatchId,
        },
      });
    },
    fetchHost(row) {
      switch (row.dispatchType) {
        case "shang_men_ti_huo":
          return "shangmentihuo";
        case "gan_xian_pei_zai":
          return "ganxian";
        case "song_huo_shang_men":
          return "songhuoshangmen";
        case "song_chu_wai_fa":
          return "songchuwaifa";
      }
      return "shangmentihuo";
    },
    // 顶部跟多按钮的操作
    topCommandBtns(command) {
      if (this.topCommandBtnsBak(command)) {
        return;
      }
      if (this.selectTableData.length === 0) {
        this.$message.warning("请先选择表格记录！");
        return;
      }
      this[command]();
    },
    // 获取营业网点
    async getBusinessDepts() {
      const data = await this.$API.runListReport({
        number: "business_dept_down_list",
      });
      this.businessDepts = data;
    },
    handleCommandBtns(command, data) {
      this[command](data);
    },
    // 新建派车--上门提货
    addNewDispatch() {
      let path = "/DispatchCar/PickupDispatchCar/add/" + this.fetchHost();
      this.$router.push({
        path,
      });
    },
    dispatchEdit(row) {
      this.$router.push({
        path: "/DispatchCar/PickupDispatchCar/edit/" + this.fetchHost(row),
        query: {
          dispatchId: row.dispatchId,
        },
      });
    },
    dispatchDetail(row) {
      this.$router.push({
        path: "/DispatchCar/CarTiming",
        query: {
          dispatchNumber: row.dispatchNumber,
        },
      });
    },
    // 途径网点
    passingBranches(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      this.dispatchId = this.selectTableData[0].dispatchId;
      this.showSetOnway = true;
      this.$nextTick(() => {
        this.$refs.passingThroughBranches.isShowDialog = true;
      });
    },
    // 中途到车/中途发车/终端到车弹窗保存回调
    saveArriveMidway() {
      this.$refs.arriveDialogFormRef.validate((valid) => {
        let path = "";
        let params = {
          dispatchIds: this.selectTableData.map((item) => item.dispatchId),
          deptId: this.arriveDiaForm.deptId,
        };
        switch (this.arriveDiaType) {
          case "ztdc":
            path = "arrivalMidway";
            params.actualArrivalTime = this.arriveDiaForm.arrivalTime;
            break;
          case "ztfc":
            path = "startMidway";
            params.departureTime = this.arriveDiaForm.arrivalTime;
            break;
          case "zddc":
            path = "arrivalEndDept";
            params.arrivalEndDeptTime = this.arriveDiaForm.arrivalTime;
            break;
        }
        this.$API[path](params).then((res) => {
          this.$message("保存成功");
        });
      });
    },
    // 中途到车
    arriveMidway(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      this.arriveDiaTitle = "中途到车";
      this.arriveDiaType = "ztdc";
      this.arriveDiaForm.timeLabel = "到车时间";
      this.arriveDiaForm.deptLabel = "到车网点";
      this.arriveDiaForm.dispatchId = ""; // row.dispatchId
      this.showArriveMidwayDia = true;
    },
    // 中途发车
    departureMidway(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      this.arriveDiaTitle = "中途发车";
      this.arriveDiaType = "ztfc";
      this.arriveDiaForm.timeLabel = "发车时间";
      this.arriveDiaForm.deptLabel = "下一站网点";
      this.arriveDiaForm.dispatchId = ""; // row.dispatchId
      this.showArriveMidwayDia = true;
    },
    // 终端到车
    terminalArrival(row) {
      if (this.selectTableData.length === 0) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      this.arriveDiaTitle = "终端到车";
      this.arriveDiaType = "zddc";
      this.arriveDiaForm.timeLabel = "到车时间";
      this.arriveDiaForm.deptLabel = "终端网点";
      this.arriveDiaForm.dispatchId = ""; // row.dispatchId
      this.showArriveMidwayDia = true;
    },
    dispatchConfirm(row) {
      let rows = [];
      if (row) {
        rows.push(row);
      } else {
        if (this.selectTableData.length == 0) {
          this.$message.warning("请选择一条运单进行操作");
          return;
        }
        rows = this.selectTableData;
      }
      console.log(rows);
      const dispatchIds = rows.map((item) => item.dispatchId);
      this.$confirm("是否对已选数据进行发车确认？", "提示")
        .then((res) => {
          this.$API
            .startCar({
              dispatchIds,
            })
            .then((res) => {
              this.$message.success("发车确认成功");
              this.getData();
            })
            .catch((res) => {
              this.$message.error("发车确认失败:" + res.data.message);
            });
        })
        .catch((err) => {});
    },
    intoStoreage() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      const row = this.selectTableData[0];
      this.$router.push({
        path: "/DispatchCar/PickupDispatchCar/add/intoStoreageDispatchCar",
        query: {
          type: this.dispatchType,
          op: "intoStoreage",
          dispatchId: row.dispatchId,
        },
      });
    },
    finishDispatch(row) {
      let rows = [];
      if (row) {
        rows.push(row);
      } else {
        if (this.selectTableData.length == 0) {
          this.$message.warning("请选择一条运单进行操作");
          return;
        }
        rows = this.selectTableData;
      }
      const dispatchIds = rows.map((item) => item.dispatchId);
      this.$confirm("是否对已选数据进行发车完成？", "提示")
        .then((res) => {
          this.$API
            .endCar({
              dispatchIds,
            })
            .then((res) => {
              this.$message.success("发车完成成功");
              this.getData();
            })
            .catch((res) => {
              this.$message.error("发车完成失败:" + res.data.message);
            });
        })
        .catch((err) => {});
    },
    feeCheckIn(row) {
      if (!row) {
        if (this.selectTableData.length !== 1) {
          this.$message.warning("请选择一条运单进行操作");
          return;
        }
        row = this.selectTableData[0];
      }
      this.$router.push({
        path: "/DispatchCar/PickupDispatchCar/add/FeeCheckInDispatchCar",
        query: {
          type: this.dispatchType,
          op: "feeCheckIn",
          dispatchId: row.dispatchId,
        },
      });
    },
    batchCheckFee(row) {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      this.$confirm("是否对已选数据进行财务审核过账？")
        .then((res) => {
          this.$API
            .batchPostingDispatch({
              dispatchIds: this.selectTableData.map((item) => item.dispatchId),
            })
            .then((res) => {
              this.$message("过账成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },
    batchCheckFeeOut() {
      if (this.selectTableData.length !== 1) {
        this.$message.warning("请选择一条运单进行操作");
        return;
      }
      this.$confirm("是否对已选数据进行反过账？")
        .then((res) => {
          this.$API
            .unpostingDispatch({
              dispatchIds: this.selectTableData.map((item) => item.dispatchId),
            })
            .then((res) => {
              this.$message("反过账成功");
              this.getData();
            });
        })
        .catch((err) => {});
    },
    allocationCarFee(row) {
      this.$router.push({
        path: "/DispatchCar/PickupDispatchCar/allocation/fee",
        query: {
          dispatchId: row.dispatchId,
        },
      });
    },
    delDispatch() {
      this.$confirm("是否对已选数据进行删除？").then((res) => {
        this.$API
          .delDispatch({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message("删除成功");
            this.getData();
          });
      });
    },
    dispatchSure() {
      this.$confirm("是否对已选数据进行调度确认？").then((res) => {
        this.$API
          .dispatchSure({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message("调度确认成功");
            this.getData();
          });
      });
    },
    cancelDispatch() {
      this.$confirm("是否对已选数据取消调度确认？").then((res) => {
        this.$API
          .cancelDispatch({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message("调度取消成功");
            this.getData();
          });
      });
    },
    receiveOrder() {
      this.$confirm("是否对已选数据进行司机接单？").then((res) => {
        this.$API
          .receiveOrder({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message("司机接单成功");
            this.getData();
          });
      });
    },
    cancelReceiveOrder() {
      this.$confirm("是否对已选数据取消司机接单？").then((res) => {
        this.$API
          .cancelReceiveOrder({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message("司机接单取消成功");
            this.getData();
          });
      });
    },
    dispatchcancelStartCar() {
      this.$confirm("是否对已选数据取消发车确认？").then((res) => {
        this.$API
          .cancelStartCar({
            dispatchIds: this.getDispatchIds(),
          })
          .then((res) => {
            this.$message("发车确认取消成功");
            this.getData();
          });
      });
    },
    getDispatchIds() {
      return this.selectTableData.map((item) => item.dispatchId);
    },
  },
};
</script>
<style scoped lang="less">
.el-dialog__wrapper {
  .el-dialog {
    .el-dialog__body {
      .glo_dialogForm {
        .dialogFormItems {
          min-width: 345px;
        }
      }
    }
  }
}
.tableBox {
  height: calc(100% - 260px);
}

.colorStyle {
  color: #f00;
}

.mdTitName {
  height: 24px;
  border: 1px solid #d7d7d7;
  text-align: center;
  min-width: 100px;
}

.queryCriteria {
  .queryItem_one {
    .queryTextarea {
      border: 1px solid #d7d7d7;
    }
  }

  .timeBox {
    border: 1px solid #d7d7d7;
  }
}

.headerboxs {
  width: 100%;
  padding: 5px 0;
  display: flex;
  align-items: center;
}

.iconInput {
  display: flex;
  align-items: center;
}
.mainCOlorBtns {
  background-color: #f0a261;
  color: #fff;
  border: none;
}
.mainCOlorBtns :hover {
  color: #fff;
}
</style>
